import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type CompetitionTeamListQueryParams = Parameters<typeof SSF.api.competitionTeamsList>[0];

export const keys = createQueryKeySet<CompetitionTeamListQueryParams>('competition-teams');

export function useCompetitionTeamListQuery(params?: CompetitionTeamListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionTeamsList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useCompetitionTeamQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionTeamsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
